import { useState } from "react";
import AviationSectorPicker from "../../../components/Sectors/AviationSectorPicker";
import FormSubmitButton from "../../../components/FormSubmitButton";
import SubFlowHeader from "../../../components/GoalSubflow/SubFlowHeader";
import OptionPills from "../../../components/GoalSubflow/OptionPills";
import { useGoalSubflow } from "./useGoalSubflow";
import { COMMUNITY_ROLE_MAX, getOptions } from "../../registry";
import { t } from "../../../../../locales/t";

/**
 * "Building your network": the networking sub-flow. `planSubFlows` decides
 * which of its questions this member is asked.
 */
const GOAL = "networking";

const Networking = () => {
  const { asks, index, total, answers, submit } = useGoalSubflow(GOAL);

  const [sectors, setSectors] = useState(
    () => answers.sectors ?? { primary: [], secondary: {} },
  );
  const [communityRole, setCommunityRole] = useState(
    () => answers.communityRole ?? [],
  );
  const [connectionTypes, setConnectionTypes] = useState(
    () => answers.connectionTypes ?? [],
  );

  // Every question this screen actually asks is required — none of them is a
  // preference, and a networking profile missing any of the three cannot be
  // matched on.
  const canContinue =
    (!asks.sectors || sectors.primary.length > 0) &&
    (!asks.communityRole || communityRole.length > 0) &&
    (!asks.connectionTypes || connectionTypes.length > 0);

  const handleContinue = () => {
    if (!canContinue) return;
    submit({
      ...(asks.sectors ? { sectors } : {}),
      ...(asks.communityRole ? { communityRole } : {}),
      ...(asks.connectionTypes ? { connectionTypes } : {}),
    });
  };

  return (
    <SubFlowHeader
      goal={GOAL}
      index={index}
      total={total}
      onSubmit={handleContinue}
    >
      {asks.sectors && (
        <AviationSectorPicker
          value={sectors}
          onChange={setSectors}
          mode={asks.sectors}
          label={t(`onboarding.subflow.${GOAL}.sectorsLabel`)}
        />
      )}

      {asks.communityRole && (
        <OptionPills
          multiple
          max={COMMUNITY_ROLE_MAX}
          options={getOptions("communityRole")}
          value={communityRole}
          onChange={setCommunityRole}
          label={t("onboarding.subflow.questions.communityRole.label")}
          hint={t("onboarding.subflow.questions.communityRole.hint")}
        />
      )}

      {asks.connectionTypes && (
        <OptionPills
          multiple
          options={getOptions("connectionTypes")}
          value={connectionTypes}
          onChange={setConnectionTypes}
          label={t("onboarding.subflow.questions.connectionTypes.label")}
        />
      )}

      <FormSubmitButton
        variant="contained"
        fullWidth
        disabledReason={!canContinue ? t("onboarding.subflow.incomplete") : ""}
        sx={{ py: 1.5 }}
      >
        {t("onboarding.subflow.continue")}
      </FormSubmitButton>
    </SubFlowHeader>
  );
};

export default Networking;
